import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { SettingService } from './../../services/setting.service';
import { EncrDecrService } from '../../services/encr-decr.service';
@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.css']
})
export class UserprofileComponent implements OnInit {
  profileForm: FormGroup;
  model:any = {};
  fileToUpload:any='';
  imagePath:any='assets/images/users/profile_pic.png';
  user_id:any='';
  company_id:any='';
  APIKEY:any='';
  profile_id:any='';
  message:string;
  currentUserRole:any='';
  abc:any=[];


  constructor(
    private _setting:SettingService,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private _router : Router,
    private fb: FormBuilder,
    private EncrDecr: EncrDecrService,) {
}
  
  ngOnInit() {
    this.profileForm = this.fb.group({
      first_name: [''],
      last_name: [''],
      phone: [''],
      email: [null, [Validators.required, Validators.email]],
      password: [''],
      role_name: [''],
      created_at: [''],
      u_status: [''],
      profile_pic: [''],
      id: [''],
    });
    
    


    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');

    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);
    this.currentUserRole= obj.role_name;




    this.model= {
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        company_id : this.company_id,
       // status : 'dinesh'
    }
    this._setting.getProfileInfo(this.model)
    .subscribe(
      res => { 
      //  console.log(res); return false;

         this.profile_id= res.data.id;
         if(res.data.image_url!=''){this.imagePath= res.data.image_url;}

         if(res.data.image_url=='' || res.data.image_url==null){
          this.imagePath='assets/images/users/profile_pic.png';
         }else{
          this.imagePath=res.data.image_url;
         }


         this.model['id']= res.data.id;
         this.model['first_name']= res.data.first_name;
         this.model['last_name']= res.data.last_name;
         this.model['phone']= res.data.phone;
         this.model['email']= res.data.email;
         //this.model['password']= res.data.password;
         this.model['password'] = this.EncrDecr.get(localStorage.getItem('key'), res.data.password);
         this.model['role_name']= res.data.role_name;
         this.model['created_at']= res.data.created_at;
         this.model['u_status']= res.data.u_status;
      },
    );
  }
  

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event:any) => {
        this.imagePath = event.target.result;
      }
      const file = event.target.files[0];
      this.profileForm.get('profile_pic').setValue(file);
     }
  }


  onSubmit() {
   
    const formData = new FormData();
    formData.append('first_name', this.profileForm.get('first_name').value);
    formData.append('last_name', this.profileForm.get('last_name').value);
    formData.append('phone', this.profileForm.get('phone').value);
    formData.append('email', this.profileForm.get('email').value);
    formData.append('password', this.EncrDecr.set(localStorage.getItem('key'), this.profileForm.get('password').value));
    //formData.append('password', this.profileForm.get('password').value);
    formData.append('profile_pic', this.profileForm.get('profile_pic').value);
    formData.append('id', this.profile_id);
    formData.append('APIKEY', this.APIKEY);
   
    this._setting.uploadProfilePic(formData).subscribe(
        res => { 
          if(res.status==true){
            // this.toastr.success(res.message, 'Success');
            this._router.navigate(['/mobile/mobile-list']).then(e=>{
              this._router.navigate(['/setting/user-profile']);
            })
            this.refresh_sidebar() ;
           
          }
          else{
             this.toastr.error(res.message, 'Error');
          }
        }  
    );

    

   }


   /// auto reload navigation code 
   refresh_sidebar() { 
      this.model= { 
        APIKEY : this.APIKEY,
        user_id : this.user_id,
        company_id : this.company_id
    };
    this._setting.getProfileInfo(this.model)
        .subscribe(
          res => { 
            console.log(res);
            this._setting.changeCurrentProfile(res.data)
            //console.log(this._setting.changeCurrentProfile);
           },
          err => {console.log(err)
            //this._app.loading = false;
            this._router.navigate(['login']);
          }
        );
    }
///end



}
